import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import SignIn from "./pages/SignIn";
import MobileApps from "./pages/MobileApps";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToHash from "ScrollToHash";
import "./App.css";
import "./i18n";

const App = () => {
  return (
    <Router>
      <ScrollToHash/>
      <Navbar />
      <Routes>
        {/* Home Page Route */}
        <Route path="/" element={<Home />} />
        {/* About Us Page Route */}
        <Route path="/about-us" element={<AboutUs />} />
        {/* Contact Us Page Route */}
        <Route path="/contact-us" element={<ContactUs />} />
        {/* Sign In Page Route */}
        <Route path="/sign-in" element={<SignIn />} />
        {/* Mobile Apps Page Route */}
        <Route path="/mobile-apps" element={<MobileApps />} />
        {/* Terms of Service Page Route */}
        <Route path="/terms-of-service" element={<TermsOfService />} />
        {/* Privacy Policy Page Route */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
